import React, { useState, useEffect } from 'react';
import Select from '../Util/Form/CustomInputs/Select';
import CustomMap from '../Util/Map/CustomMap';
import Fetch from '../functions/Fetch';
import config from '../../../../config/config';
import { useSelector } from 'react-redux';

import '../home/Home.css';

function Units(props) {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [unitsOptions, setUnitsOptions] = useState([]);
  const [markerPosition, setMarkerPosition] = useState({});
  const [cityAndUf, setCityAndUf] = useState({});
  const [optionsLoaded, setOptionsLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      let options = [];
      let getUnits = await Fetch.post(`${config.endpoints.backend}portal/getallunits`, { filter: { friendly_url } });
      if (getUnits.length > 0) {
        getUnits.forEach((unit) => {
          options.push({
            label: unit.no_fantasia,
            value: {
              ...unit,
              lat: parseFloat(unit.nu_latitude) ? parseFloat(unit.nu_latitude) : null,
              lng: parseFloat(unit.nu_longitude) ? parseFloat(unit.nu_longitude) : null
            }
          });
        });
      }

      setUnitsOptions(options);
      setMarkerPosition(options[0].value);
      console.log(options[0].value)
      searchByZipcode(options[0].value.co_cep);
      setOptionsLoaded(true); // Indica que as opções estão carregadas
    };
    load();
  }, []);

  const checkZipCode = async (zipcode) => {
    let url = "https://busca-cep.wservices.cc/?key=b9b8fd0be0a17e80bdf05ada87691531&cep=";
    let result
    if (zipcode && zipcode.length >= 8) {
      url = url + zipcode;
      result = await Fetch.get(url);
    }

    if (result.status == 1) {

      return result.result;
    } else {
      return {
        status: 0,
        municipio: null,
        estado: null,
      }
    }
  }

  const searchByZipcode = async (zipcode) => {
    const fullAddress = await checkZipCode(zipcode)
    const cityAndUfToSet = {
      municipio: fullAddress.municipio,
      estado: fullAddress.uf
    }
    setCityAndUf(cityAndUfToSet)
  }


  const handleChangeUnit = async (selectedValue) => {
    searchByZipcode(selectedValue.target.value.co_cep)
    setMarkerPosition(selectedValue.target.value);
  };

  return (
    <section className="content pr-3 pl-3 w-100" style={{ marginTop: '30px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card card-outline" style={{ borderTop: `3px solid` }}>
              <div className="card-header" style={{ borderBottom: '0' }}>
                <h3 className="card-title"><i className={`fa-solid fa-building mr-1`}></i>Unidades</h3>
              </div>
              <div className="row m-0">
                <div className="col-4">
                  {optionsLoaded && (
                    <Select
                      name={"unit_select"}
                      isClearable={false}
                      onChange={(selectedValue) => { handleChangeUnit(selectedValue) }}
                      value={markerPosition}
                      options={unitsOptions}
                      disabled={false}
                    />
                  )}
                  <div className="p-2 mt-2 mb-2" style={{ borderLeft: `0.25rem solid ${props.primary_color}` }}>
                    <label className="m-0">{markerPosition.co_cnes ? markerPosition.co_cnes : "CNES não informado"}</label>
                    <p className="m-0 mb-2 text-muted">CNES</p>

                    <label className="m-0">{markerPosition.no_razao_social ? markerPosition.no_razao_social : "Razão Social não informada"}</label>
                    <p className="m-0 mb-2 text-muted">Razão social</p>

                    <label className="m-0">{`${markerPosition.no_logradouro ? markerPosition.no_logradouro : "Logradouro não informado"}, ${markerPosition.nu_endereco ? markerPosition.nu_endereco : "Número não informado"}`}</label>
                    <p className="m-0 mb-2 text-muted">Endereço</p>

                    <label className="m-0">{markerPosition.no_bairro ? markerPosition.no_bairro : "Bairro não informado"}</label>
                    <p className="m-0 mb-2 text-muted">Bairro</p>

                    <label className="m-0">{markerPosition.no_complemento ? markerPosition.no_complemento : "Complemento não informado"}</label>
                    <p className="m-0 mb-2 text-muted">Complemento</p>

                    {cityAndUf && (
                      <>
                        <label className="m-0">{cityAndUf.municipio ? cityAndUf.municipio : "Município não informado"}</label>
                        <p className="m-0 mb-2 text-muted">Município</p>
                        <label className="m-0">{cityAndUf.estado ? cityAndUf.estado : "Estado não informado"}</label>
                        <p className="m-0 mb-2 text-muted">Estado</p>
                      </>
                    )}
                  </div>
                </div>
                <div className="col pb-2">
                  {markerPosition.lng && markerPosition.lat &&
                    <CustomMap markerPosition={markerPosition} draggable={false} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
}

export default Units;
